module.exports.deposit = `
  INSERT INTO fin.txn_entry (
      origin, company, txn_type, txn_id, txn_date,
      amount, currency, account_id, entry_type, customer_id
  )
  SELECT t.origin
       , t.company
       , t.txn_type
       , t.txn_id
       , t.txn_date
       , l.amount
       , m.currency
       , m.account_id
       , 'debit'::fin.entry_type as entry_type
       , l.customer_id
  FROM txn t
  INNER JOIN main m USING (origin, company, txn_id)
  INNER JOIN line l USING (origin, company, txn_id)
  UNION ALL
  SELECT t.origin
       , t.company
       , t.txn_type
       , t.txn_id
       , t.txn_date
       , l.amount
       , m.currency
       , l.account_id
       , 'credit'::fin.entry_type as entry_type
       , l.customer_id
  FROM txn t
  INNER JOIN main m USING (origin, company, txn_id)
  INNER JOIN line l USING (origin, company, txn_id)
`

module.exports.invoice = `
  INSERT INTO fin.txn_entry (
      origin, company, txn_type, txn_id, txn_date,
      currency, account_id, entry_type, customer_id, amount
  )
  SELECT t.origin
       , t.company
       , t.txn_type
       , t.txn_id
       , t.txn_date
       , m.currency
       , a.account_id
       , 'debit'::fin.entry_type as entry_type
       , m.customer_id
       , m.amount
  FROM txn t
  INNER JOIN main m USING (origin, company, txn_id)
  CROSS JOIN LATERAL (
    SELECT *
    FROM fin.account_config a
    WHERE a.origin = t.origin
      AND a.company = t.company
      AND a.account_type = 'accounts-receivable'
    LIMIT 1
  ) a
  UNION ALL
  SELECT t.origin
       , t.company
       , t.txn_type
       , t.txn_id
       , t.txn_date
       , m.currency
       , l.account_id
       , 'credit'::fin.entry_type as entry_type
       , m.customer_id
       , sum(l.amount)
  FROM txn t
  INNER JOIN main m USING (origin, company, txn_id)
  INNER JOIN line l USING (origin, company, txn_id)
  GROUP BY 1, 2, 3, 4, 5, 6, 7, 8, 9
`

module.exports.creditmemo = `
  INSERT INTO fin.txn_entry (
      origin, company, txn_type, txn_id, txn_date,
      currency, account_id, entry_type, customer_id, amount
  )
  SELECT t.origin
       , t.company
       , t.txn_type
       , t.txn_id
       , t.txn_date
       , m.currency
       , a.account_id
       , 'credit'::fin.entry_type as entry_type
       , m.customer_id
       , m.amount
  FROM txn t
  INNER JOIN main m USING (origin, company, txn_id)
  CROSS JOIN LATERAL (
    SELECT *
    FROM fin.account_config a
    WHERE a.origin = t.origin
      AND a.company = t.company
      AND a.account_type = 'accounts-receivable'
    LIMIT 1
  ) a
  UNION ALL
  SELECT t.origin
       , t.company
       , t.txn_type
       , t.txn_id
       , t.txn_date
       , m.currency
       , l.account_id
       , 'debit'::fin.entry_type as entry_type
       , m.customer_id
       , sum(l.amount)
  FROM txn t
  INNER JOIN main m USING (origin, company, txn_id)
  INNER JOIN line l USING (origin, company, txn_id)
  GROUP BY 1, 2, 3, 4, 5, 6, 7, 8, 9
`

module.exports.payment = `
  WITH cash_payment AS (
    SELECT t.origin
         , t.company
         , t.txn_type
         , t.txn_id
         , t.txn_date
         , currency
         , m.account_id as debit_account_id
         , a.account_id as credit_account_id
         , customer_id
         , amount
    FROM txn t
    LEFT JOIN main m USING (origin, company, txn_id)
    CROSS JOIN LATERAL (
      SELECT *
      FROM fin.account_config a
      WHERE a.origin = t.origin
        AND a.company = t.company
        AND a.account_type = 'accounts-receivable'
      LIMIT 1
    ) a
    WHERE m.account_id IS NOT NULL AND m.amount != 0
  )
  INSERT INTO fin.txn_entry (
      origin, company, txn_type, txn_id, txn_date,
      currency, account_id, entry_type, customer_id, amount
  )
  SELECT origin, company, txn_type, txn_id, txn_date,
         currency, debit_account_id, 'debit'::fin.entry_type, customer_id, amount
  FROM cash_payment
  UNION ALL
  SELECT origin, company, txn_type, txn_id, txn_date,
         currency, credit_account_id, 'credit'::fin.entry_type, customer_id, amount
  FROM cash_payment
`

module.exports.journalentry = `
  INSERT INTO fin.txn_entry (
      origin, company, txn_type, txn_id, txn_date,
      currency, account_id, entry_type, customer_id, amount
  )
  SELECT t.origin
       , t.company
       , t.txn_type
       , t.txn_id
       , t.txn_date
       , m.currency
       , l.account_id
       , l.entry_type
       , l.customer_id
       , l.amount
  FROM txn t
  LEFT JOIN main m USING (origin, company, txn_id)
  LEFT JOIN line l USING (origin, company, txn_id)
`

module.exports.purchase = `
  INSERT INTO fin.txn_entry (
      origin, company, txn_type, txn_id, txn_date,
      currency, account_id, entry_type, customer_id, amount
  )
  SELECT t.origin
       , t.company
       , t.txn_type
       , t.txn_id
       , t.txn_date
       , currency
       , account_id
       , 'credit'::fin.entry_type as entry_type
       , customer_id
       , amount
  FROM txn t
  LEFT JOIN main m USING (origin, company, txn_id)
  UNION ALL
  SELECT t.origin
       , t.company
       , t.txn_type
       , t.txn_id
       , t.txn_date
       , m.currency
       , l.account_id
       , 'debit'::fin.entry_type as entry_type
       , l.customer_id
       , l.amount
  FROM txn t
  LEFT JOIN main m USING (origin, company, txn_id)
  LEFT JOIN line l USING (origin, company, txn_id)
`
